import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '../context/useUserContext';
import { useProjectContext } from '../context/useProjectContext';
import LoaderComponent from '../Components/Generic/LoaderComponent';

const AdminRoute = ({ children }) => {
    const { user } = useUserContext();
    const { selectedProject, isAdmin } = useProjectContext();
    const location = useLocation();
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        if (user !== undefined && selectedProject !== undefined) {
            setIsChecking(false);
        }
    }, [user, selectedProject]);

    // Show loader while checking
    if (isChecking) {
        return <LoaderComponent loading={true} />;
    }

    // Redirect to dashboard if not admin
    if (!isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default AdminRoute;